import { DataExport } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const useDataExportFeatureGate = () => usePlanFeatureGate(DataExport);
